var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('f7-navbar',{attrs:{"title":"Error","back-link":""}}),_c('f7-block',{attrs:{"strong":""}},[_c('p',[_vm._v("Sorry")]),_c('p',[_vm._v(_vm._s(_vm.message))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }